import { Action } from '../../../../../../dispatcher/Types';

export const OpenActivityMonitor: Action = [{

}];
